import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

class CausePrincipaleDetailSelect extends React.Component {
    render() {
        const { value, onChange, causePrincipaleDetails, error } = this.props;

        return (
            causePrincipaleDetails && (
                <TextField
                    select
                    required={false}
                    error={error !== undefined}
                    name="causePrincipaleDetailId"
                    label="Détail de la cause principale"
                    value={value}
                    onChange={onChange}
                    helperText={error ? error.errorMsg : ''}
                    fullWidth
                >
                    <MenuItem key={0} value={0}>
                        {""}
                    </MenuItem>
                    {causePrincipaleDetails.map(type => (
                        <MenuItem key={type.id} value={type.id}>
                            {type.libelle}
                        </MenuItem>
                    ))}
                </TextField>
            )
        );
    }
}

CausePrincipaleDetailSelect.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    causePrincipaleDetails: PropTypes.array.isRequired,
    error: PropTypes.object
};

export default CausePrincipaleDetailSelect;